module.exports = __webpack_public_path__ + "img/louis-l.-redding.9582d3de.png";